// Compatibility redirect for `/profile/:id` (T-325).
//
// Until T-325 every "View in PeopleAwesomeness" link the server produced
// pointed at `/profile/{employeeId}?tab=timeoff`, a route this app has
// never had, so those links landed on the 404 page. The server now writes
// `/employees/:id` (see `apps/api/src/platform/urls.ts`), but the broken
// links are already sitting in Slack messages and inboxes, and those
// cannot be rewritten.
//
// So the old path resolves here and forwards, preserving the query string
// (`?tab=timeoff` is what makes the link land on the right tab) and any
// hash. `replace` keeps the dead URL out of the history stack, so Back
// goes where the user came from rather than bouncing through the
// redirect.
//
// This is a shim, not a second source of truth: new links must come from
// the server helper.

import { Navigate, useLocation, useParams } from 'react-router-dom';

export default function LegacyProfileRedirect() {
  const { id } = useParams<{ id: string }>();
  const { search, hash } = useLocation();

  // No id means the link was truncated somewhere; the directory is the
  // closest useful destination.
  if (!id) return <Navigate to="/employees" replace />;

  return <Navigate to={`/employees/${id}${search}${hash}`} replace />;
}
